var _defs, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-2{fill:none;stroke:#686c80;stroke-linecap:round;stroke-width:2px}"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16856",
    "data-name": "Group 16856",
    transform: "translate(-757.788 -244.676)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16437",
    "data-name": "Rectangle 16437",
    width: 24,
    height: 24,
    rx: 8,
    transform: "translate(757.788 244.676)",
    style: {
      fill: "none"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Line_2",
    "data-name": "Line 2",
    className: "cls-2",
    transform: "translate(764.69 251.367)",
    d: "m0 0 10.407 10.407"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Line_3",
    "data-name": "Line 3",
    className: "cls-2",
    transform: "translate(764.69 251.367)",
    d: "M10.407 0 0 10.407"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/iconClose.ffa8f9cacdee5a92793737ccbec30883.svg";
export { ForwardRef as ReactComponent };